import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { Checkbox } from '../../../components/Checkbox';
import { Cell, List, Row } from '../../../components/List';
import { IsOpen } from '../../../components/Icon';
import cn from 'classnames';
import styles from './RDWandHistoryCard.module.css';
import { fetchVehicleRecommendations } from '../actions';
import { selectWork } from '../../Api/selectors';
import { REQUEST_VEHICLE_RECOMMENDATIONS } from '../constants';
import { Loader } from '../../../components/Loader';
import { Button } from '../../../components/Buttons';
import { CompanyDataCard } from '../../Companies/components/CardData';
import { CompanyLabelById } from '../../Companies/components/CompanyLabelById';

const Container = styled.div`

`;

const STATE = {
    isOpen: false,
};
/* eslint-disable react/prefer-stateless-function */
class VehicleRecommendationCardComp extends BaseComponent {
    constructor(props) {
        super(props, {
            ...STATE,
        });
    }

    parse({ response }) {
        if (response && response.result) {
            this.setState({ companyIds: response.result });
        } else {
            console.error('Invalid response or result is null/undefined:', response);
            // Optionally, you can set a default value or handle this scenario in another way
            this.setState({ companyIds: [] }); // or null, depending on your use case
        }
    }
    componentDidMount() {
        this.props.fetch(this.parse.bind(this));
    }

    render() {
        if (this.props.loading) return <Loader small />
        const vehicle = this.props.vehicle;
        return (
            <Container>
                <Card className={cn('vehicle-info-card info-card info', styles.card)}>
                    <h2>Recommendations:</h2>

                    {/* <Button onClick={() => this.props.fetch(this.parse.bind(this))}>Refresh</Button> */}

                    {
                        this.state.companyIds ? this.state.companyIds.map((id, index) => <div style={{ padding: '12px', border: '1px solid black' }} key={id}>
                            <CompanyLabelById company_id={id} />
                        </div>) : null
                    }


                </Card>
            </Container>
        );
    }
}

VehicleRecommendationCardComp.propTypes = {
    dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({
    loading: selectWork(REQUEST_VEHICLE_RECOMMENDATIONS)
});

function mapDispatchToProps(dispatch, ownProps) {
    return {
        dispatch,
        fetch(cb) {
            dispatch(fetchVehicleRecommendations(ownProps.vehicle.id, cb));
        }
    };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleRecommendationCard = compose(withConnect, withRouter)(VehicleRecommendationCardComp);
